import { FilterParams } from "../types/filterAndPaginationTypes";

export function convertParamsToQueryOptions({ page, pageSize, sortBy, sortOrder, ...filters }: FilterParams) {
    return {
        sortBy: sortBy,
        sortOrder: sortOrder,
        ...(pageSize && { pageSize: parseInt(pageSize) }),
        ...(page && { page: parseInt(page) }),
        ...filters,
    };
}

export function convertParamsToQueryOptionsArray({ page, pageSize, sortBy, sortOrder, ...filters }: FilterParams) {
    const filters_ = Object.entries(filters)
        .filter(([_, value]) => {
            return value !== undefined;
        })
        .map(([key, value]) => {
            const valueConverted = typeof value === "string" && value.includes(",") ? value.split(",") : value;
            return [key, valueConverted];
        });

    return {
        ...Object.fromEntries(filters_),
        sortBy,
        sortOrder,
        pageSize: typeof pageSize === "string" ? parseInt(pageSize) : undefined,
        page: typeof page === "string" ? parseInt(page) : undefined,
    };
}
